module.exports = __webpack_public_path__ + "55b920b07e66a672ea56553352c42803.png";